import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
var innerSvg = '<path d="M22.83 4a1 1 0 00-2 0v21.41L15.73 20a1 1 0 00-1.41-.06 1 1 0 00-.05 1.42l6.85 7.32a1 1 0 001.47 0L29.73 21a1 1 0 00-1.46-1.36l-5.44 5.83z"/><path d="M9.17 28a1 1 0 002 0V6.59l5.1 5.41a1 1 0 001.41.06 1 1 0 00.05-1.42l-6.85-7.32a1 1 0 00-1.47 0L2.27 11a1 1 0 101.46 1.36l5.44-5.83z"/>';
export var SortOutlineSVG = function SortOutlineSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
SortOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(SortOutlineSVG);